import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export default function ConditionalLink({ children, condition, ...props }) {
  return condition && props.to ? (
    <CustomLink {...props}>{children}</CustomLink>
  ) : (
    <>{children}</>
  );
}

const CustomLink = styled(Link)`
  &:hover,
  &:focus {
    outline: none;
  }

  &:hover > div:first-of-type {
    box-shadow: 0px 0px 0px 2px
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.primaryAA
          : props.theme.color.primaryFull};
  }
  &:focus-visible > div:first-of-type {
    box-shadow: 0px 0px 0px 2px
      ${(props) =>
        props.theme.name === 'light'
          ? props.theme.color.statusLightFocus
          : props.theme.color.statusDarkFocus};
  }
`;
